var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircularAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0.5C11.6421 0.5 15 3.85786 15 8C15 12.1421 11.6421 15.5 7.5 15.5C3.35786 15.5 0 12.1421 0 8C0 3.85786 3.35786 0.5 7.5 0.5ZM7.5 1.5C3.91015 1.5 1 4.41015 1 8C1 11.5899 3.91015 14.5 7.5 14.5C11.0899 14.5 14 11.5899 14 8C14 4.41015 11.0899 1.5 7.5 1.5ZM7.5 4.75C7.84493 4.75 8.125 5.03007 8.125 5.375V7.375H10.125L10.2275 7.38379C10.4936 7.42782 10.7033 7.63978 10.7432 7.90723L10.75 8L10.7432 8.09277C10.6983 8.39378 10.4384 8.625 10.125 8.625H8.125V10.625L8.11816 10.7178C8.07329 11.0188 7.81341 11.25 7.5 11.25C7.15507 11.25 6.875 10.9699 6.875 10.625V8.625H4.875L4.78223 8.61816C4.48122 8.57329 4.25 8.31341 4.25 8C4.25 7.65507 4.53007 7.375 4.875 7.375H6.875V5.375L6.88184 5.28223C6.92671 4.98122 7.18659 4.75 7.5 4.75Z",
    fill: "#587E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularAdd);
export default __webpack_public_path__ + "static/media/circular-add.08bd91038b19eadd9fffb9c8baa2d573.svg";
export { ForwardRef as ReactComponent };